import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

import ServerInfoConnection from 'workspaces/launcher/connections/ServerInfoConnection';
import ServerInfoConstants from 'workspaces/launcher/constants/ServerInfoConstants';

import ErrorData from 'sharedreact/data/ErrorData';

function _onFetchSuccess (data: {isAEOnPremises: boolean, isAESaaS: boolean, isAEPS2: boolean, isFlexoTools: boolean}) {
  AppDispatcher.dispatch({
    actionType: ServerInfoConstants.GET_SUCCESS,
    isAEOnPremises: data.isAEOnPremises,
    isAESaaS: data.isAESaaS,
    isAEPS2: data.isAEPS2,
    isFlexoTools: data.isFlexoTools,
    logLevel: 'debug'
  });
}

function _onFetchFailure (error: ErrorData) {
  AppDispatcher.dispatch({
    actionType: ServerInfoConstants.GET_FAIL,
    error: error,
    logLevel: 'error'
  });
}

function fetch () {
  ServerInfoConnection.fetch(_onFetchSuccess, _onFetchFailure);
}

const ServerinfoActions = {
  fetch
};

export default ServerinfoActions;
